import { Card, CardContent } from '@/components/ui/card';
import { IonRouterLink } from '@ionic/react';
import { GolfAvatar } from './ui/GolfAvatar';
import FriendshipButton from './FriendshipButton';

type FriendSuggestionCardProps = {
  name: string;
  userId: string;
  username: string;
  imageUrl: string;
};

export function FriendSuggestionCard({ userId, name, username, imageUrl }: FriendSuggestionCardProps) {
  return (
    <Card className="w-[190px]">
      <CardContent className="p-2">
        <div className="flex flex-col justify-between items-center space-y-2">
          <IonRouterLink routerDirection='forward' routerLink={`/u/${username}`} className="font-semibold m-2 hover:underline">
            <GolfAvatar
              imageUrl={imageUrl}
              username={username}
              name={name}
              size={88}
            />
          </IonRouterLink>
          <div className="text-center">
            <IonRouterLink routerDirection='forward' routerLink={`/u/${username}`} className="font-medium hover:underline">
              {name}
            </IonRouterLink>
          </div>
          <FriendshipButton withIcon={false} dontCheckOnInit userId={userId} />
        </div>
      </CardContent>
    </Card>
  );
}
